import PropTypes from 'prop-types';
import React from 'react';

import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import { SOCIAL_SHARE_TYPES } from 'dpl/shared/constants/social';
import { getSocialShareLink } from 'dpl/util/social';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import ActionButton from 'dpl/puppy_page/components/ActionButton';

import { useBreederProfileData } from '../hooks/useBreederProfileData';

export default function BreederProfileShareButton({
  analytics,
  children,
  iconSize,
  iconClassName,
  ...props
}) {
  const { shareMeta } = useBreederProfileData();

  function handleClick() {
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      ...analytics,
      button_cta: 'share_icon',
      view_feature: ANALYTICS_VIEW_FEATURES.SHARE_ICON
    });

    if (window.navigator.share) {
      window.navigator.share({
        title: shareMeta.page_title,
        text: shareMeta.page_description,
        url: shareMeta.page_url
      });
    } else {
      window.open(
        getSocialShareLink(
          SOCIAL_SHARE_TYPES.EMAIL,
          shareMeta.page_url,
          shareMeta.page_title
        )
      );
    }
  }

  return (
    <ActionButton
      {...props}
      iconClassName={iconClassName}
      iconName="fetch-share"
      onClick={handleClick}
      iconSize={iconSize}
    >
      {children}
    </ActionButton>
  );
}

BreederProfileShareButton.propTypes = {
  analytics: PropTypes.shape({
    view: PropTypes.string,
    view_feature_location: PropTypes.string
  }),
  children: PropTypes.node,
  iconSize: PropTypes.string,
  iconClassName: PropTypes.string
};

BreederProfileShareButton.defaultProps = {
  analytics: {},
  children: null,
  iconClassName: null,
  iconSize: '24px'
};
